// Sistem tek para birimi kullanır: Türk Lirası.
export const CURRENCY_CODE = "TRY";
export const CURRENCY_SYMBOL = "₺";

// 1500 -> "₺1.500,00"
export const formatTRY = (amount) => {
  const num = Number(amount);
  if (amount === null || amount === undefined || amount === "" || Number.isNaN(num)) {
    return `${CURRENCY_SYMBOL}0,00`;
  }
  return `${CURRENCY_SYMBOL}${num.toLocaleString("tr-TR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};
